<template>
    <div class="main">


        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Manufacturers</h3>
            </div>
            <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
                <a-button @click="showManufacturerModal"
                    style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                    icon="plus">
                    Add New Manufacturer
                </a-button>
            </div>
            <div>
                <a-table :columns="manufacturersColumns" :data-source="tableManufacturerData" :loading="tableLoading"
                    :pagination="pagination" class="tableStyle">
                    <template slot="action" slot-scope="data">
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a @click="showUpdateManufacturerModel(data)">Edit Manufacturer?</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>
                    <template slot="status" slot-scope="data">
                        <div v-if="data.status === 1">
                            <a-switch default-checked checkedChildren="Enabled" unCheckedChildren="Disabled"
                                @change="manufacturerOnChange" @click="switchManufacturerStatus(data)" />
                        </div>
                        <div v-else>
                            <a-switch checkedChildren="Enabled" unCheckedChildren="Disabled"
                                @change="manufacturerOnChange" @click="switchManufacturerStatus(data)" />
                        </div>
                    </template>
                </a-table>
            </div>

            <a-modal class="modalStyle" :visible="addManufacturerVisible" :footer="null"
                @cancel="handleAddManufacturerCancel">

                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                    Add
                    Manufacturer</p>
                <div>
                    <a-form-model ref="addManufacturerForm" :model="addManufacturerModel" :rules="rules">
                        <a-row>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Manufacturer Name" ref="manufacturerName"
                                    prop="manufacturerName">
                                    <a-input class="" v-model="addManufacturerModel.manufacturerName" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Manufacturer Description" ref="manufacturerDescription"
                                    prop="manufacturerDescription">
                                    <a-input class="" v-model="addManufacturerModel.manufacturerDescription" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <!-- <a-spin class="spinner" :spinning="loading" /> -->
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button :loading="loading" @click="handleManufacturerSubmit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Add Manufacturer
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
            <a-modal class="modalStyle" :visible="updateManufacturerVisible" :footer="null"
                @cancel="handleUpdateManufacturerCancel">

                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                    Edit
                    Manufacturer</p>
                <div>
                    <a-form-model ref="updateManufacturerForm" :model="updateManufacturerModel" :rules="rules">
                        <a-row>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Manufacturer Name" ref="manufacturerName"
                                    prop="manufacturerName">
                                    <a-input class="" v-model="updateManufacturerModel.manufacturerName" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Manufacturer Description" ref="manufacturerDescription"
                                    prop="manufacturerDescription">
                                    <a-input class="" v-model="updateManufacturerModel.manufacturerDescription" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleUpdateManufacturerSubmit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Edit Manufacturer
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

const manufacturersColumns = [
    {
        title: 'Manufacturer ID',
        // width: 150,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Manufacturer Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
    },
    {
        title: 'Manufacturer Description',
        // width: 150,
        key: 'description',
        dataIndex: 'description',
    },
    {
        title: 'Created At',
        // width: 150,
        key: 'dateCreated',
        dataIndex: 'dateCreated',
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },
]
    export default {
        name: 'Manufacturers',
        data(){
            return{
                tableManufacturerData:[],
                tableLoading: false,
                manufacturersColumns,
                pagination: {
                    pageSize:20
                },
                isManufacturerEnabled: Boolean,
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
                addManufacturerModel: {
                    manufacturerName:'',
                    manufacturerDescription: ''
                },
                updateManufacturerModel: {
                    manufacturerName:'',
                    manufacturerDescription: ''
                },
                addManufacturerVisible: false,
                updateManufacturerVisible: false,
                dateFormat: 'DD/MM/YYYY',
                startDate: moment(),
                endDate: moment(),
                loading: false,
                selectedManufacturer:{},
                rules:{
                    notes: [
                        { required: true, message: 'Please this field cannot be empty' , trigger: 'change'},
                    ],
                    name: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    
                    manufacturerName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    description: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    manufacturerDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    supplierName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    supplierAddress: [
                        { required: true, message: 'Please enter address' , trigger: 'change'},
                    ],
                    supplierPhoneNumber: [
                        { required: true, message: 'Please enter phone number' , trigger: 'change'},
                    ],
                    supplierDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    categoryName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    categoryDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    categoryGroup: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    isRestricted: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    categoryCommission: [
                        { required: true, message: 'Please enter commission', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                }
            }
        },
        computed:{
            ...mapGetters(['IsAgentProfileAvailable']),
        },
        methods:{
          ...mapActions(['getAllProductsMgtData','addProductManufacturer','updateProductManufacturer']),
          onChange(date, dateString) {
                // console.log(date, dateString);
                this.startDate = dateString[0];
                this.endDate = dateString[1];
                // console.log("startDate | ", this.startDate);
                // console.log("endDate | ", this.endDate);
            },
            moment,
            showUpdateManufacturerModel(data){
                this.selectedManufacturer = data
                this.updateManufacturerModel.manufacturerName = data.name
                this.updateManufacturerModel.manufacturerDescription = data.description
                this.updateManufacturerVisible = true;
            },
            handleUpdateManufacturerCancel(){
                this.updateManufacturerVisible = false;
            },
            manufacturerOnChange(checked){
                this.isManufacturerEnabled = checked
            },
            showManufacturerModal(){
                this.addManufacturerVisible = true;
            },
            
            handleAddManufacturerCancel(){
                this.addManufacturerVisible = false;
            },
            handleUpdateManufacturerSubmit(){
                this.$refs.updateManufacturerForm.validate(valid => {
                        if (valid) {
                            this.loading = true;
                            const request = {
                                id: this.selectedManufacturer.id,
                                data: {
                                    name:  this.updateManufacturerModel.manufacturerName,
                                    description: this.updateManufacturerModel.manufacturerDescription,
                                    status: this.selectedManufacturer.status
                                }
                            }

                            
                            this.updateProductManufacturer(request).then(response => {
                                
                                this.loading = false;
                                if(response.status === 200){
                                    this.getProductsMgtData();
                                    this.showSuccessAlert("Manufacturer Updated Successfully")
                                    this.updateManufacturerVisible = false;
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })                    
                        } else {
                            // console.log('error submit!!');
                            return false;
                        }
                });
            },
           
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            handleManufacturerSubmit(){
                this.$refs.addManufacturerForm.validate(valid => {
                        if (valid) {
                            this.loading = true;
                            const request = {
                                name:  this.addManufacturerModel.manufacturerName,
                                description: this.addManufacturerModel.manufacturerDescription,
                                status: 1
                            }
        
                            
                            this.addProductManufacturer(request).then(response => {
                                
                                this.loading = false;
                                if(response.status === 200){
                                    this.getProductsMgtData();
                                    this.showSuccessAlert("Manufacturer Added Successfully")
                                    this.addManufacturerVisible = false;
                                    this.$refs.addManufacturerForm.resetFields();
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })                    
                        } else {
                            // console.log('error submit!!');
                            return false;
                        }
                });
            },
            switchManufacturerStatus(data){
                this.tableLoading = true
                const request = {
                    id: data.id,
                    data: {
                        name:  data.name,
                        description: data.description,
                        status: this.isManufacturerEnabled === true ? 1 : 0
                    }
                }

                this.updateProductManufacturer(request).then(response => {
                    
                    this.tableLoading = false;
                    if(response.status === 200){
                        this.getProductsMgtData();
                        if(this.isManufacturerEnabled){
                            this.showSuccessAlert(`Manufacturer [ ${data.name} ] Enabled Successfully`)
                        }else{
                            this.showSuccessAlert(`Manufacturer [ ${data.name} ] Disabled Successfully`)
                        }
                    }else{
                        this.tableLoading = false;
                        this.showErrorAlert(response.data.messages)
                    }
                },
                error =>{
                    this.tableLoading = false
                    this.showErrorAlert(JSON.stringify(error))
                }) 
                
            },
            getAllManufacturersData(response){
                if(response.status === 200){
                    
                    this.tableManufacturerData = response.data.data.map(manufacturer => ({
                        id: manufacturer.id,
                        key: manufacturer.id,
                        name: manufacturer.name,
                        description: manufacturer.description,
                        status: manufacturer,
                        dateCreated: moment(manufacturer.createdAt).format('DD-MM-YYYY'),
                        action: manufacturer
                    }))
                    // this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
                }else{
                    console.log("Error | " , response)
                }
            },
            async getProductsMgtData(){
                this.tableLoading =  true;
                const response = await this.getAllProductsMgtData();
                this.getAllManufacturersData(response[3])
            
                this.tableLoading =  false;
            }
            
            },
        created() {
          
          if(this.getProductsMgtData){
              this.getProductsMgtData();
          }
         
        }
    }
</script>

<style scoped>

.actions{
    display: flex;
    justify-content: space-between;
}
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.orderTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.orderTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
a {
  color: #418a49;
}
a:hover{
  color: #418a49;
}
button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}
.orderTable >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

</style>